export default __webpack_public_path__ + "static/media/eji-image.2026bb34.png";